<template>
  <el-sub-menu :index="index" v-bind:class="aclass">
    <template #title>{{ text }}</template>
    <el-sub-menu index="50-0" v-if="companies.length > 0">
      <template #title>
        <span>{{ $t('navbar.company') }}: {{ currentCompanyCode }}</span>
      </template>
      <el-menu-item v-for="company in companies" :key="company.code" :index="`50-0-${company.code}`"
        @click="selectCompany(company.code)" :class="{ 'is-active': company.code === currentCompanyCode }">
        {{ company.code }} - {{ company.name }}
      </el-menu-item>
    </el-sub-menu>
    <el-menu-item @click="$router.push({ name: 'logout' })" index="50-1">{{ $t('navbar.logout') }}</el-menu-item>
    <el-sub-menu index="50-2">
      <template #title>{{ $t('navbar.language') }}</template>
      <el-menu-item index="50-2-1" @click="setLocale('lv')">Latviešu</el-menu-item>
      <el-menu-item index="50-2-2" @click="setLocale('en')">English</el-menu-item>
    </el-sub-menu>
  </el-sub-menu>
</template>

<script>
import { ElMessage } from 'element-plus';
import { computed } from 'vue';
import { useI18n } from "vue3-i18n";
import { useStore } from 'vuex';

export default {
  name: "NavbarMenu",
  props: {
    text: String,
    index: String,
    aclass: String,
  },
  setup() {
    const store = useStore()
    const i18n = useI18n();

    const companies = computed(() => store.state.auth.companies || [])
    const currentCompany = computed(() => store.state.auth.current_company)
    const currentCompanyCode = computed(() => currentCompany.value?.company_code || '')
    const currentCompanyName = computed(() => currentCompany.value?.company_name || '')

    const setLocale = (locale) => {
      store.dispatch("ui/set_locale", { locale: locale })
      i18n.setLocale(locale);
    }

    const selectCompany = async (company_code) => {
      try {
        await store.dispatch('auth/setCompany', company_code)
        ElMessage.success(i18n.t('navbar.company_changed'))
        // Reload the page to refresh data with new company context
        window.location.reload()
      } catch (error) {
        ElMessage.error(i18n.t('navbar.company_change_error'))
      }
    }

    return {
      setLocale,
      selectCompany,
      companies,
      currentCompanyCode,
      currentCompanyName
    }
  }
}
</script>

<style>
a {
  text-decoration: none;
}

/* Dropdown menu styling - NOT scoped so it applies to popper */
.el-menu--popup {
  background-color: #2c3e50 !important;
  border: 1px solid rgba(64, 158, 255, 0.3) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3) !important;
}

.el-menu--popup .el-menu-item {
  color: #ffffff !important;
  background-color: transparent !important;
}

.el-menu--popup .el-menu-item:hover {
  background-color: rgba(64, 158, 255, 0.2) !important;
  color: #ffffff !important;
}

.el-menu--popup .el-menu-item.is-active {
  background-color: rgba(64, 158, 255, 0.3) !important;
  color: #409eff !important;
}

.el-menu--popup .el-sub-menu__title {
  color: #ffffff !important;
  background-color: transparent !important;
}

.el-menu--popup .el-sub-menu__title:hover {
  background-color: rgba(64, 158, 255, 0.2) !important;
}
</style>
